import { motion, useReducedMotion } from "motion/react"
import type { ReactNode } from "react"

interface RevealBlockProps {
  children: ReactNode
  delay?: number
  className?: string
}

/**
 * Standard scroll-triggered fade-up. Smooth and cinematic — no bounce.
 * Fires once when the element enters the viewport.
 * Degrades to an opacity-only fade when the user prefers reduced motion.
 */
export function RevealBlock({
  children,
  delay = 0,
  className,
}: RevealBlockProps) {
  const reduceMotion = useReducedMotion()

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduceMotion ? 0 : 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{
        duration: 0.8,
        ease: "easeOut",
        delay,
      }}
    >
      {children}
    </motion.div>
  )
}
